import { Model } from "app/pages/company-display/component/CompanyDetails/Model";
import { ModelWrapper } from "app/pages/company/component/ModelWrapper";
import { SocialShare } from "app/pages/component/SocialShare";
import AuthNavComponent from "app/pages/module/auth/AuthNav";
import Footer from "app/pages/module/Footer";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Input } from "sr/helpers";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { Button } from "sr/helpers/ui-components/company/Button";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { fetchcleaner } from "sr/redux/reducers/cleaner";
import { AppDispatch } from "sr/redux/store";
import { createRedeemOrder } from "sr/utils/api/cleaner/reward/createRedeemOrder";
import { getRedeemCategory } from "sr/utils/api/cleaner/reward/getRedeemCategory";
import { getReferralWallet } from "sr/utils/api/cleaner/reward/getReferralWallet";

export const Reward = () => {
    const [referLink, setReferLink] = useState<string>('')
    const [copied, setCopied] = useState(false)
    const [openPopup, setOpenPopup] = useState(false)
    const [cleanerId, setCleanerId] = useState<string>('')
    const data = useSelector((state:any)=> state.cleaner.data)
    const [wallet, setWallet] = useState(null)
    const [loader, setLoader] = useState('wallet')
    const [redeemClicked, setRedeemClicked] = useState(false)
    const [rewardCategory, setRewardCategory] = useState(null)
    const [amount, setAmount] = useState(0)
    const [utid, setUtid] = useState('')
    const [customError, setCustomError] = useState('')
    useEffect(()=>{
        if(data?.referral_code){
            setReferLink(`https://app.janitorialmarketplace.org/create-cleaner?code=${data?.referral_code}`)
        }
    },[data])
    useEffect(()=>{
        const {user_id} = getUserDetails()
        setCleanerId(user_id)
    },[])
    const dispath = useDispatch<AppDispatch>()
useEffect(()=>{
if(cleanerId){
    if(data)
   dispath(fetchcleaner({id:cleanerId})) 
}
},[cleanerId])
      const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset message after 2 seconds
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
const fetchReferralWallet = async (cleanerId)=> {
    try {
    const queryParams = new URLSearchParams()
    queryParams.append('cleaner_id', cleanerId)
    const res = await getReferralWallet(queryParams)
    if(res?.success===true){
        setWallet(res?.data)
        setLoader('')
        return true
    }
    else {

    }
}
catch(e){

}
}
useEffect(()=>{
if(cleanerId){
    fetchReferralWallet(cleanerId)
}
},[cleanerId])
const fetchCategory = async ()=> {
try{
const res = await getRedeemCategory()
if(res.success===true){
setRewardCategory(res?.data?.brands)
}
}
catch(e){

}
}
useEffect(()=>{
fetchCategory()
},[])

const handleOrderCreate = async ()=>{
    if(Number(amount)<1){
        setCustomError("INPUT.VALIDATION.AMOUNT.ADD.ERROR")
        setTimeout(() => {
           setCustomError('')
        }, 1000);
        return
    }
    // Harendra open this block
    // if(Number(amount) >Number(wallet?.amount)){
    //     toast.error("Insufficient funds")
    //     return
    // }
    try{
    setLoader('giftcardcreate')
const payload = {
utid:utid,
email:data.email,
firstName:data.first_name,
lastName:data.last_name,
amount:amount,
cleaner_id:cleanerId
}
const res = await createRedeemOrder(payload)
if(res?.success===true){
    
    await fetchReferralWallet(cleanerId)
    toast.success("Gift Card Created Successfully")
    setLoader('')
    setAmount(null)
    setUtid('')
    
}
    }
    catch(e){

    }
    finally{
setLoader('')
    }
}
  return (
  <>
             <AuthNavComponent isLoggedin={true}></AuthNavComponent>
             <ContentWithSpinner loader={loader==='wallet'} height="h-screen">
                {loader==='giftcardcreate' && <LoaderFullScreen></LoaderFullScreen>}
<div className="lg:container mx-auto lg:max-w-6xl lg:mt-5 mt-5 px-4 lg:px-0">
<h1 className="text-2xl font-bold mb-3">Reward</h1>
<p className="text-xl mb-5">Earn rewards ($5) when your friends join JaniJobs</p>

<Button onClick={()=> setOpenPopup(true)} buttoncss="text-xl bg-[#ff39b3] cursor-pointer leading-[0.5]" padding={'p-4'}  justify="justify-start" text={'Refer and Earn'}></Button>
<p className="pt-1 text-base">Your Referral Code:<span>{data?.referral_code}</span></p>
<div className="flex w-[50rem] space-x-3 items-center mt-3">
<Input inputClass="rounded-lg" InputDivClass="w-full" labelClass="font-bold text-lg" label={'Refer Link'}  readOnly={true} value={referLink}></Input>
<Button onClick={handleCopy} buttoncss="text-xl bg-[#ff39b3]  leading-[0.5]" padding={'p-3'} margin={'mt-7'}  justify="justify-start" text={'Copy Link'}></Button>
</div>
      {copied && <p className="text-green-600 mt-2">Link copied to clipboard!</p>}

<div className="my-5">
<div className="flex space-x-3">
<div className="flex text-xl space-x-2 items-center">
<p>Reward Balance:</p>
<p>${wallet?.amount ||'0.00'}</p>

<h1 onClick={()=> setRedeemClicked(true)} className="text-[#ff39b3] font-bold cursor-pointer">Redeem</h1>
</div>    
</div>
{redeemClicked && 
<div className="flex space-x-6 mt-5 flex-wrap">
    {rewardCategory?.map((item, index)=> (
    <div key={index} className="border border-neutral-200 p-2 cursor-pointer hover:bg-gray-100 hover:border-gray-200 relative">
        <img onClick={()=> setUtid(item?.items[0].utid)} src={item?.imageUrls?.['130w-326ppi']}></img>
        {item?.items[0].utid === utid &&
        <div className="w-6 h-6 rounded-full bg-[#0078ae] absolute top-2">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 text-white p-0.5 font-bold">
  <path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clipRule="evenodd" />
</svg>
</div>
}
        </div>
        ))}
        </div>
}
{
    utid && <div className="w-[25rem]">
           <Input 
           prefix="$" 
           label={'Enter Amount'}
           error={customError}
           InputDivClass="mt-0 w-26 pr-2 pb-2 mt-6"  
          inputClass="border border-zinc-800 rounded-lg [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
           value={amount} onChange={(e)=>setAmount(e.target.value)} type="number"></Input>
           <div onClick={handleOrderCreate} className="text-center rounded-lg bg-[#ff39b3] font-bold px-5 py-2  text-white cursor-pointer hover:bg-navy" >Submit</div>
</div>
}
</div></div>
{openPopup &&
<ModelWrapper background="bg-[#00000099]" opacity="opacity-100" position="inset-0 mx-auto fixed top-[40%]" width="xl:w-[25%] lg:w-[25%] w-[50%] mx-auto" HandleModelByProps={()=> setOpenPopup(false)} showModal={openPopup} >
    <div className="flex px-3 justify-between items-center border-b py-3 border-neutral-200">
        <h1 className="text-xl font-bold">Refer and Earn</h1>
    <span onClick={()=> setOpenPopup(false)} className="bg-transparent cursor-pointer right-0 text-black opacity-1 h-6 w-6 text-2xl block outline-none focus:outline-none">×</span>
    
    </div>

    <div className="px-3 text-center">
        <p className="pt-3">Share this link by</p>
    <SocialShare fullLink={referLink} title="Sign up for JaniJobs using my referral code 93843 to receive a $5 gift card!" className="justify-center"></SocialShare>
    </div>
</ModelWrapper>
}
</ContentWithSpinner>
<Footer></Footer>
  </>
);
};
